import * as dayjs from 'dayjs';
import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';
import trim from 'lodash-es/trim';
import { RouterCreationDto } from './api/core';
import { apiCallService } from '@liebherr/old-sage-ui';

export function decreaseLoading(currentLoading: number) {
    if (currentLoading - 1 < 0) {
        return 0;
    } else {
        return currentLoading - 1;
    }
}

export function getLoggedInUserData() {
    const token = localStorage.getItem('access_token');

    return token ? JSON.parse(atob(token.split('.')[1])) : undefined;
}

export function registerApiCall(actionCallback: () => void, actionType: string) {
    actionCallback();
    return apiCallService.register(actionType);
}

export function clearEmptyValue(value: any) {
    const val = trim(value);
    return !isNil(val) && !isEmpty(val) && val !== '' ? val : undefined;
}

export function formatDeviceDate(device: RouterCreationDto) {
    return {
        ...device,
        simExpirationDate: device.simExpirationDate ? dayjs(mapCSVDeviceDate(device.simExpirationDate)).format('YYYY-MM-DD') : undefined,
    };
}

export enum DialogWidths {
    SMALL = '350px',
    MID = '550px',
}

function mapCSVDeviceDate(date?: string) {
    // date comes from csv and must have format like 18.12.2022 -> map to 2022-12-18 to enable dayjs to read it
    if (date) {
        const [day, month, year] = date.split('.');
        return [year, month, day].join('-');
    } else {
        return undefined;
    }
}

/**
 * Collect roles from token based on availability.
 * token.groups is default claim for roles.
 *
 * @param oidcClientId needed when roles are expected to be in token.resource_access[oidcClientId].roles
 */
export function collectRoles(token: any, oidcClientId?: string) {
    let roles: string[] = [];
    if (token?.groups) {
        roles = token?.groups;
    } else if (token?.realm_access?.roles) {
        roles = token?.groups;
    } else if (!isNil(oidcClientId) && (token?.resource_access || {})[oidcClientId]?.roles) {
        roles = (token?.resource_access || {})[oidcClientId]?.roles;
    }
    return roles || [];
}
